import {highlightYellow} from './highlightYellow';
import {TemplatePurposes} from '../EmailEditor';

export const getProvideOptions = (d: any) => {
    const hasGUL = d.some((data: any) => data.product_type === 'GUL');
    const hasTerm = d.some((data: any) => data.product_type === 'Term');
    const hasIUL = d.some((data: any) => data.product_type === 'IUL');

    const header =
        d[0].template_purpose === TemplatePurposes.quoted
            ? 'Our life insurance policies provide:'
            : "In summary of what we've discussed, our life insurance policies can provide:";

    const IUL = `<p><strong>${header}</strong></p>
<ol>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Immediate life insurance protection</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Immediate critical, chronic, and terminal illness protection</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">A savings account that can be accessed in cash tax-free after 10 years</span></li>
</ol>`;

    const Term = `<p><strong>${header}</strong></p>
<ol>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Immediate life insurance protection</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Immediate critical, chronic, and terminal illness protection </span></li>
</ol>`;

    const GUL = `<p><strong>${header}</strong></p>
<ol>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Coverage that lasts for the rest of your life</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Pays out for life, critical, chronic, and terminal illness emergencies</span></li>
</ol>`;

    if (hasIUL) {
        return IUL;
    }

    if (hasTerm) {
        return Term;
    }

    if (hasGUL) {
        return GUL;
    }

    return '';
};
